import P from 'components/P';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import React, { useState } from 'react';

// 공통 스타일 변수
// const fontSize = 'min(3vw, 25px)';
const fontSize = 'max(1.2vw, 8px)';

const VendorStoreAutoOrderList = ({ order }) => {
    // 주문 날짜를 띄어쓰기를 기준으로 분할하여 날짜와 시간 추출
    const splittedDate = order.storeOrderDate.split(' ');
    const orderDate = splittedDate[0];
    const orderTime = splittedDate[1];

    // 리스트 스타일 정의
    const [isHovered, setIsHovered] = useState(false);
    const listStyle = {
        padding: '0.5rem 0',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all 0.4s',
        borderBottom: '1px solid #eee',
        // hover 상태일 때의 스타일
        ...(isHovered && {
            backgroundColor: '#eee',
            // 다른 hover 스타일 추가 가능
        }),
    };

    return (
        <div
            style={listStyle}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <HorizontalFlex padding="1em 0" gap="1em">
                <FlexChild>
                    <VerticalFlex>
                        <FlexChild alignItems="flex-start">
                            <P size={fontSize}>{orderDate}</P>
                            <P size={fontSize}>{orderTime}</P>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex>
                        <FlexChild alignItems="flex-start">
                            <P size={fontSize}>{order.storeOrderId}</P>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex>
                        <FlexChild alignItems="flex-start">
                            <P size={fontSize}>{order.storeOrderName}</P>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex>
                        <FlexChild alignItems="flex-start">
                            <P size={fontSize}>{order.storeOrderItemName}</P>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex>
                        <FlexChild alignItems="flex-start">
                            <P size={fontSize}>{order.storeOrderItemCnt}</P>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex>
                        <FlexChild alignItems="flex-start">
                            <P size={fontSize}>
                                {order.storeOrderPrice.toLocaleString()}원
                            </P>
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </HorizontalFlex>
        </div>
    );
};

export default VendorStoreAutoOrderList;
